import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8k3spdpm72: FaireBrandEntity = {
  token: "b_8k3spdpm72",
  type: "brand",
  name: "El Rudo Gourmet Inc.",
  avatarUrl:
    "https://cdn.faire.com/fastly/df2052f5b75cebf172cf2e371bb98feca698f085cb5cb05a267d8b916066c580.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/bef3d071da545b5a03b9fb9b2ef2eb2144d87fe7a08da401749e7c0b20cdb230.png",
  logoUrl:
    "https://cdn.faire.com/fastly/df2052f5b75cebf172cf2e371bb98feca698f085cb5cb05a267d8b916066c580.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/bef3d071da545b5a03b9fb9b2ef2eb2144d87fe7a08da401749e7c0b20cdb230.png",
  location: "Markham, ON, CAN",
  minimumOrderDollars: 80,
  rating: 5,
  reviewCount: 1,
  isInsider: false,
  description:
    "Salsa Macha is a bold, versatile chili oil sauce inspired by a traditional Mexican condiment with a rich and mysterious heritage. At El Rudo, we created our own Mexican-Canadian interpretation: an oil-based condiment crafted with carefully selected dried chiles, seeds, garlic, and tamarind for a distinctive balance of smokiness, savory depth, and approachable heat.\n\nDesigned for today’s consumers, El Rudo Salsa Macha delivers premium flavor in a format that fits effortlessly into everyday cooking. It is more than a hot sauce or chili oil. It is a finishing condiment that adds texture, richness, and complexity to a wide range of dishes, making it easy for customers to elevate meals at home.\n\nIts versatility is one of its greatest strengths. Spoon it over eggs, avocado toast, tacos, pizza, noodles, grain bowls, roasted vegetables, sandwiches, burgers, grilled meats, or seafood. This broad usage makes it especially appealing to food lovers seeking globally inspired flavors that feel both exciting and accessible.\n\nEl Rudo stands out on shelf by combining authentic Mexican inspiration with a modern, gourmet positioning. Bold yet balanced, it is approachable for a wide audience while offering enough personality to feel truly distinctive.",
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:25:48.514Z",
    importedBy: "entity-db-cli",
  },
};
